import store from '@/store'
import {
  PATH_NAME_COIN_CHARGE_FOR_DCB,
  PATH_NAME_REGIST,
  PATH_NAME_REVOCATION_DEFENCE,
  PATH_NAME_SUBS_COIN_CHARGE_FOR_GOOGLE_IN_APP,
  PATH_NAME_TERMS_COIN_CHARGE_FOR_GOOGLE_IN_APP,
  PATH_NAME_VOUCHER,
  PATH_NAME_VOUCHER_INDEX,
  PATH_NAME_VOUCHER_POPUP_INFO,
  PATH_NAME_VOUCHER_POPUP_NEW_FOR_APP,
  PATH_NAME_VOUCHER_PROMOTION,
  PATH_NAME_WAVVEON
} from '@/common/router.const'

export default [
  {
    path: '/voucher',
    name: PATH_NAME_VOUCHER,
    components: {
      voucher: () => import('@/views/voucher/Voucher')
    },
    beforeEnter: (to, from, next) => {
      if (from.name !== 'voucher_popup_info') {
        store.commit('setBeforePathOpenMyPooq', from.fullPath)
      }
      next()
    },
    children: [
      {
        path: 'index',
        name: PATH_NAME_VOUCHER_INDEX,
        alias: 'index.html',
        components: {
          index: () => import('@/components/lnb/voucher/index')
        }
      },
      {
        path: 'regist',
        name: PATH_NAME_REGIST,
        alias: 'regist.html',
        components: {
          regist: () => import('@/components/lnb/voucher/RegistVoucher')
        }
      },
      {
        path: 'wavveon',
        name: PATH_NAME_WAVVEON,
        alias: 'wavveon.html',
        components: {
          pooqzone: () => import('@/components/lnb/voucher/PooqZoneVoucher')
        }
      },
      {
        path: 'promotion',
        name: PATH_NAME_VOUCHER_PROMOTION,
        alias: 'promotion.html',
        components: {
          voucher_promotion: () => import('@/components/lnb/voucher/voucher_promotion')
        }
      }
    ]
  },
  {
    path: '/voucher/dcbcoin',
    name: PATH_NAME_COIN_CHARGE_FOR_DCB,
    alias: 'dcbcoin.html',
    components: {
      voucher: () => import('@/views/voucher/DcbCoin.vue')
    }
  },
  {
    path: '/voucher/google/terms_coin',
    name: PATH_NAME_TERMS_COIN_CHARGE_FOR_GOOGLE_IN_APP,
    alias: '/voucher/google/term_coin.html',
    components: {
      voucher: () => import('@/views/voucher/ChargeCoinForGoogleIAP')
    }
  },
  {
    path: '/voucher/google/subs_coin',
    name: PATH_NAME_SUBS_COIN_CHARGE_FOR_GOOGLE_IN_APP,
    alias: '/voucher/google/subs_coin.html',
    components: {
      voucher: () => import('@/views/voucher/ChargeCoinForGoogleIAP')
    }
  },
  {
    path: '/voucher/popup_new.html',
    name: PATH_NAME_VOUCHER_POPUP_NEW_FOR_APP,
    components: {
      voucher_popup_new: () => import('@/views/voucher/VoucherPopup')
    }
  },
  {
    path: '/voucher/revocation_defense',
    name: PATH_NAME_REVOCATION_DEFENCE,
    alias: '/voucher/revocation_defense.html',
    components: {
      revocation_defense: () => import('@/views/revocation_popup/RevocationDefense')
    }
  },
  {
    path: '/voucher/popup/info',
    name: PATH_NAME_VOUCHER_POPUP_INFO,
    components: {
      voucher_popup_info: () => import('@/components/voucher/popup/VoucherPopupInfo')
    }
  }
]
